import script from "./file.vue?vue&type=script&setup=true&lang=js"
export * from "./file.vue?vue&type=script&setup=true&lang=js"

import "./file.vue?vue&type=style&index=0&id=090c6d26&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-090c6d26"]])

export default __exports__